<template>
  <div
    class="row pt-4 pb-4 px-2 px-lg-0 bg-white"
    v-if="highlightsList.length > 0"
  >
    <div class="col-12 pb-0 pt-0 pb-lg-4 pt-lg-4">
      <!-- Title -->
      <div v-if="propDisplayTitle" class="text-center mb-4" :class="propFullwidth ? '' : 'mx-auto custom-width'">

        <h2 class="values-section-title mt-4">Nos Activité</h2>
        <p class="values-section-desc mt-4"> Explorez nos dernières initiatives</p>

        <hr class="mx-auto" style="width: 40px; border-top: 2px solid #ced4da;" />

      </div>

      <!-- Content -->
      <div class="row justify-content-center" :class="propFullwidth ? '' : 'mx-auto custom-width'">
        <div
          v-for="announcement in highlightsList"
          :key="announcement.id"
          class="col-md-4 col-lg-4 col-12 d-flex align-items-stretch mb-4"
        >
          <div class="border-0 w-100 m-3">
            <div class="position-relative">
              <img
                :src="'/api/image/get/' + announcement.image"
                class="card-img-top"
                style="object-fit: cover; height: 300px; width: 100%; border-radius: 6px; "
                alt="Image annonce"
              />
            </div>

            <div class="justify-content-between row text-dark  mt-auto align-items-center" style="width: 95%;">
              <div v-if="propDisplayTitle" class="col-6 mt-2 pt-1 pl-1 font-weight-bold text-left ">
                  <i class="bx bx-calendar me-1"></i> {{announcement.date}}
                </div>

                <div v-if="propDisplayTitle" class="col-6 mt-2 pt-1 pl-1 text-right font-size-16">
                  <span v-if="announcement.tag" class="badge bg-primary text-white ">
                    <strong>{{announcement.tag}}</strong> 
                  </span>
                </div> 
            </div>


            <div class="d-flex flex-column p-2">

              <h5
                class="font-weight-bold text-dark mb-2 text-uppercase"
                id="annoucement-title-small"
                :title="announcement.title"
              >
                {{ announcement.title }}
              </h5>

              <p
                class="card-text text-muted flex-grow-1"
                style="color: #000 !important;"
                :class="{ 'limited-lines': !expandedItems.includes(announcement.id) }"
                v-html="announcement.description"
              ></p>

              <a
                v-if="shouldShowReadMore(announcement.description)"
                href="#"
                class="mt-2 text-primary small font-weight-semibold"
                @click.prevent="toggleDescription(announcement.id)"
              >
                {{ expandedItems.includes(announcement.id) ? 'Afficher moins...' : 'Afficher plus...' }}
              </a>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnnouncementsApi from "@/services/announcements-api";
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  props: {
    propDisplayTitle: {
      type: Boolean,
      default: true,
    },
    propWhiteBackground: {
      type: Boolean,
      default: true,
    },
    propFullwidth: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      highlightsList: [],
      expandedItems: [],

    };
  },

  mounted() {
    this.getPromotionsAndNews();
  },

  methods: {
    getPromotionsAndNews() {
      AnnouncementsApi.getPromotionsAndNews(1, 100).then((result) => {
        if (result) {
          this.highlightsList = result.list;
        }
      });
    },

    shouldShowReadMore(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      const text = div.innerText || div.textContent || "";
      const lineCount = Math.ceil(text.length / 100);
      return lineCount > 5;
    },

    toggleDescription(id) {
      const index = this.expandedItems.indexOf(id);
      if (index === -1) {
        this.expandedItems.push(id);
      } else {
        this.expandedItems.splice(index, 1);
      }
    },
  },

};
</script>

<style scoped>
.custom-width {
  width: 90%;
}
@media (min-width: 992px) {
  .custom-width {
    width: 80%;
  }
}

.hover-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 8px;
}
.hover-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.card-body small {
  font-size: 0.75rem;
  color: #6c757d;
}
.card-body a {
  text-decoration: none;
  font-weight: 600;
}
.card-body a:hover {
  text-decoration: underline;
}

#annoucement-title-small {
  font-family: "Open Sans", arial, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  height: 36px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  margin-top: 0px;
}

.limited-lines {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.875rem;
}
</style>


<style scoped>

.section-bg-title {
  font-size: 1.6rem;
  color: rgba(0, 0, 0, 0.05); /* Faint gray */
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, -60%);
  /* margin: 0; */
  z-index: 0;
  pointer-events: none;
  font-style: italic;
  font-weight: bold;
  white-space: nowrap;
}

/* Medium screens (≥768px) */
@media (min-width: 600px) {
  .section-bg-title {
    font-size: 2.8rem;
  }
}

/* Large screens (≥992px) */
@media (min-width: 992px) {
  .section-bg-title {
    font-size: 3rem;
  }
}

/* Extra large screens (≥1200px) */
@media (min-width: 1200px) {
  .section-bg-title {
    font-size: 4rem;
  }
}


.section-bg-sub-title {
  font-size: 1rem;
}

/* Medium screens (≥768px) */
@media (min-width: 768px) {
  .section-bg-sub-title {
    font-size: 1.1rem;
  }
}

/* Large screens (≥992px) */
@media (min-width: 992px) {
  .section-bg-sub-title {
    font-size: 1.3rem;
  }
}

/* Extra large screens (≥1200px) */
@media (min-width: 1200px) {
  .section-bg-sub-title {
    font-size: 1.5rem;
  }
}


.values-section-title {
  font-weight: 900;
  font-style: Black;
  font-size: 53px;
  line-height: 24px;
  text-align: center;
  vertical-align: middle;
  color: #50C7C7;
}

.values-section-desc {
  padding-top: 35px;
  font-weight: 400;
  font-size: 32.6px;
  line-height: 40px;
  text-align: center;
  vertical-align: middle;
  color: #737373;
}
</style>